import { z } from 'zod';

export const TraitsSchema = z
  .object({
    id: z.union([z.string(), z.number()]).nullable().optional(),
    email: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    phone_number: z.string().nullable().optional(),
    totp_enabled: z.boolean().nullable().optional(),
    first_name: z.string().nullable().optional(),
    middle_name: z.string().nullable().optional(),
    last_name: z.string().nullable().optional(),
  })
  .transform((raw) => ({
    id: raw.id ? String(raw.id) : null,
    email: raw.email,
    phone: raw.phone ?? raw.phone_number,
    totpEnabled: raw.totp_enabled ?? true,
    givenName: raw.first_name,
    middleName: raw.middle_name,
    familyName: raw.last_name,
  }));

export const SessionSchema = z.object({
  id: z.string(),
  identity: z.object({
    id: z.string(),
    traits: TraitsSchema,
  }),
});

export type Session = z.infer<typeof SessionSchema>;
export type SessionApi = z.input<typeof SessionSchema>;
